/* @flow */

export default {
  PORTFOLIO_SERVICE_MESSAGE_LINE1: "oneDLC.dealer.service.label1",
  PORTFOLIO_SERVICE_MESSAGE_LINE2: "oneDLC.dealer.service.label2",
  RESET_FILTERS: "oneDLC.filters.reset",
  OPEN_FILTERS_TOOLTIP: "oneDLC.filters.tooltip.open",
  CLOSE_FILTERS_TOOLTIP: "oneDLC.filters.tooltip.close",
  DEALERS_SEARCH_FIELD_LABEL_LOCATION: "oneDLC.search.field.label.location",
  DEALERS_SEARCH_FIELD_LABEL_NAME: "oneDLC.search.field.label.name",
  DEALERS_SEARCH_LOAD_MORE_LABEL: "oneDLC.search.loadMore.button.label",
  BOTTOM_BAR_MORE_INFO_LABEL: "oneDLC.topbar.moreInfo.button.label",
  LINK_PHONE_CTA: "oneDLC.link.phone.cta.label",
  LINK_PHONE_CTA_URL: "oneDLC.link.phone.cta.url",
  LINK_NEW_CARS_CTA: "oneDLC.link.newCars.cta.label",
  LINK_NEW_CARS_CTA_URL: "oneDLC.link.newCars.cta.url",
  LINK_USED_CARS_CTA: "oneDLC.link.usedCars.cta.label",
  LINK_USED_CARS_CTA_URL: "oneDLC.link.usedCars.cta.url",
  LINK_GENERIC_CARS_CTA: "oneDLC.link.genericCars.cta.label",
  LINK_GENERIC_CARS_CTA_URL: "oneDLC.link.genericCars.cta.url",
  DEALER_BOOKINGS_HEADLINE: "oneDLC.dealer.bookings.headline",
  DEALER_STORE_HEADLINE: "oneDLC.dealer.store.headline",
  DEALER_LINKOUTS_HEADLINE: "oneDLC.dealer.linkouts.headline",
  AIR_DISTANCE_LABEL: "oneDLC.distance.air.label",
  DRIVING_DISTANCE_LABEL: "oneDLC.distance.driving.label",
  TOPBAR_TOGGLE: "oneDLC.paragraph.topbar.toggle.label",
  DEEP_LINK_HEADLINE: "oneDLC.deeplink.headline.application.label",
  SHOW_ALL_DEALERS: "oneDLC.deeplink.topBar.showAllDealers.label",
  DEALERS_RETAIL_HEADLINE: "oneDLC.retail.dealers.label",
  LOCATE_ME_BLOCKED: "oneDLC.locateMe.blocked",
  HIGHLIGHT_LABEL_AMG: "oneDLC.highlights.amg.label",
  HIGHLIGHT_LABEL_EQ: "oneDLC.highlights.eq.label",
  HIGHLIGHT_LABEL_EQCHARGER: "oneDLC.highlights.eqcharger.label",
  HIGHLIGHT_LABEL_PARTSPRO: "oneDLC.highlights.partspro.label",
  HIGHLIGHT_LABEL_WEBPARTS: "oneDLC.highlights.webparts.label",
  HIGHLIGHT_LABEL_JUNGESTERNE: "oneDLC.highlights.jungesterne.label",
  HIGHLIGHT_LABEL_MBCERTIFIED: "oneDLC.highlights.mbcertified.label",
  PHONE_DISCLAIMER_LINE_1: "oneDLC.phone.disclaimer.line1",
  PHONE_DISCLAIMER_LINE_2: "oneDLC.phone.disclaimer.line2",
  PHONE_DISCLAIMER_LINE_3: "oneDLC.phone.disclaimer.line3"
};
